import { FormikProps } from 'formik';
import React from 'react';
import { UpdateDepositValues } from 'types';
import { PhotoFormView } from '.';
import { MAX_FILE_SIZE } from 'utils/files';
interface Props {
  isSubmitting: boolean;
}

export const UpdatePhotoForm: React.FC<Props & FormikProps<UpdateDepositValues>> = ({
  values,
  setFieldValue,
  isSubmitting,
  handleSubmit,
}) => {
  return (
    <PhotoFormView
      values={values}
      setFieldValue={setFieldValue}
      max={50}
      maxFileSize={MAX_FILE_SIZE}
      showActions={false}
      isSubmitting={isSubmitting}
      onReturn={() => undefined}
      handleSubmit={handleSubmit}
    />
  );
};
